import type { FC } from 'react';
import { useCallback, useEffect } from 'react';
import clsx from 'clsx';

import { getMainContentContainerId } from 'store/conference/helpers/getSharingVideoContainerId';

import MediaContent from 'components/Pages/Call/MediaContent';

import { screenShareManager } from 'manager/screenShareManager';
import { videoManager } from 'manager/videoManager';

import { useMainScreenPartContext } from '../MainScreenPartContext';
import styles from './styles.module.scss';

/** Центральная часть приложения */
const Main: FC = () => {
    const { activeUser } = useMainScreenPartContext();

    const drawVideoFunction = useCallback(() => {
        if (activeUser?.id && !activeUser.isSharing) {
            videoManager.getVideoManagerByUserId(activeUser.id)?.drawMain();
        }
    }, [activeUser?.id, activeUser?.isSharing]);

    useEffect(() => {
        if (activeUser?.id && activeUser?.isSharing) {
            screenShareManager.getScreenShareManagerByUserId(activeUser.id)?.draw();
        }
    }, [activeUser?.id, activeUser?.isSharing]);

    return (
        <div className={clsx(styles.mainContent, { [styles.mainContentIsSharing]: activeUser?.isSharing })}>
            <div className={clsx(styles.mainContentContainer, 'main-content-container')} id={getMainContentContainerId()} />
            {activeUser && !activeUser.isSharing && <MediaContent location='center' drawVideoFunction={drawVideoFunction} {...activeUser} />}
        </div>
    );
};

export default Main;
